module.exports = __webpack_public_path__ + "img/arrow-counterclockwise.96f3cc6c.svg";